import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/tx_PurchasePlanConfirms/load',
    method: 'post',
    data
  });
}

export function Confirm(data) {
  return request({
    url: '/tx_PurchasePlanConfirms/Confirm',
    method: 'post',
    data
  });
}

export function get(paramStr) {
  return request({
    url: '/Tx_PurchasePlanConfirms/Get',
    method: 'post',
    data: { paramStr }
  });
}

export function Commit(paramStr) {
  return request({
    url: '/Tx_PurchasePlanConfirms/PurchasePlaToOrderPlan',
    method: 'post',
    data: { paramStr }
  });
}

